import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
  const { jwtToken, userRoles } = useAuth();
  const location = useLocation();

  if (!jwtToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && !userRoles.includes(requiredRole)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
